export default {
  data() {
    return {
      resultsToShow: 0,
      observer: null,
      currentTabLength: 0,
      savedPos: 0,
      showMobileMore: false
    }
  },
  mounted() {
    window.addEventListener('orientationchange', this.showAllResults)
    this.observer = new IntersectionObserver(entries => {
      this.handleIntersect(entries[0]);
    }, this.options);
    if (this.$refs.trigger) this.observer.observe(this.$refs.trigger)
  },
  beforeDestroy() {
    this.observer.disconnect()
    window.removeEventListener('orientationchange', this.showAllResults)
  },
  computed: {
    mobile() {
      return this.$mq === 'xs'
    },
    overviewMode() {
      return this.$store.state.displayOverview
    },
    searchModel() {
      return this.$store.state.searchModel
    },
    assonanceConsonanceOff() {
      return !this.$store.state.preSubmissionOptions.displayConsonance
        && !this.$store.state.preSubmissionOptions.displayAssonance

    },
    assonanceMode() {
      return this.$store.state.preSubmissionOptions.displayAssonance
        && !this.$store.state.preSubmissionOptions.displayConsonance

    },
    consonanceMode() {
      return this.$store.state.preSubmissionOptions.displayConsonance
        && !this.$store.state.preSubmissionOptions.displayAssonance
    },
    bibleResponse() {
      return this.searchModel == 'xxsonance' ? this.assonanceMode ?
        this.$store.state.bibleAssonanceResponse : this.consonanceMode ?
          this.$store.state.bibleConsonanceResponse : this.assonanceConsonanceOff ? [] : this.$store.state.charuzitBibleResponse : this.$store.state.charuzitBibleResponse
    },
    hebrew() {
      return this.$settings.hebrew
    },
    selectedWords() {
      return this.$store.state.personalWords
    }
  },
  methods: {
    showAllResults() { //for orientation switch show all results to prevent confusion
      this.resultsToShow = this.currentTabLength
    },
    modalClosed() {
      this.showMobileMore = false
      this.$nextTick(function () {
        window.scroll(0, this.savedPos)
      })
    },
    modalShow() {
      history.pushState('', document.title, window.location.pathname + window.location.search)
    },
    handleIntersect(entry) {
      if (entry.isIntersecting) {
        setTimeout(() => {
          this.showMoreResults()
        }, 400)
      }
    },
    showMoreResults() {
      this.resultsToShow += 14
      if (this.resultsToShow >= this.currentTabLength - 14) {
        this.resultsToShow = this.currentTabLength
      }
    },
    setVisibleResults() {
      this.currentTabLength >= 14 ? this.resultsToShow = 14 : this.resultsToShow = this.currentTabLength
      if (window.innerWidth > window.innerHeight)
        this.showAllResults //if landscape show all results
      else
        this.showMoreResults()
    },
    addToList(word) {
      this.$store.commit('ADD_WORD_TO_LIST', word)
    },
    removeFromList(word) {
      this.$store.commit('REMOVE_WORD_FROM_LIST', word)
    },
    addToListMobile(word) {
      var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
      if (isMobile) {
        this.$store.commit('ADD_WORD_TO_LIST', word)
      }
    },
    copyMobileResult(e) {
      if (e.target.tagName !== 'I') {
        var str = ''
        var elm
        if (e.target.tagName !== 'LI') {
          elm = e.target.closest('li');
        } else {
          elm = e.target
        }
        str = elm.getElementsByTagName('p')[0].innerHTML
        if (str.includes('<b>'))
          str = elm.getElementsByTagName('b')[0].innerHTML
        str = str.trim()
        const el = document.createElement('textarea')
        const s = document.createTextNode(str)
        el.id = 'tempText'
        el.readOnly = true
        el.contentEditable = true
        el.classList.add("position-absolute")
        el.appendChild(s)
        if (document.body.classList.contains('modal-open')) {
          document.getElementById('mobile-more-modal').getElementsByClassName("modal-body")[0].appendChild(el)
        } else {
          document.body.appendChild(el)
        }
        var isiOSDevice = navigator.userAgent.match(/ipad|iphone/i)
        if (isiOSDevice) {
          var range, selection
          range = document.createRange()
          range.selectNodeContents(el)
          selection = window.getSelection()
          selection.removeAllRanges()
          selection.addRange(range)
          el.setSelectionRange(0, 999999)
        } else {
          el.select()
        }
        el.focus()
        document.execCommand("copy")
        document.getElementById('text-copied-message').style.display = 'block'
        setTimeout(() => { document.getElementById('text-copied-message').style.display = 'none' }, 2000)
        if (document.body.classList.contains('modal-open')) {
          document.getElementById('mobile-more-modal').getElementsByClassName("modal-body")[0].removeChild(el)
        } else {
          document.body.removeChild(el)
        }
      }
    }
  }
}